/**
 * Decides which month a date-picker calendar should display when it opens.
 *
 * react-day-picker does NOT navigate to the `selected` date on its own — without
 * an explicit `defaultMonth` it always opens on the current month. That caused
 * two bugs:
 *   1. Reopening a picker that already had a date selected jumped back to today's
 *      month, forcing the user to navigate forward again.
 *   2. The return picker, before a return date was chosen, showed today's month
 *      with several greyed-out months instead of opening at the pickup month.
 *
 * Rule:
 *   - if a date is already selected, show its month;
 *   - else show the contextual fallback (e.g. the pickup date for the return
 *     field);
 *   - else `undefined`, letting react-day-picker fall back to today.
 */
export function initialVisibleMonth(
  selected: Date | undefined,
  fallback?: Date,
): Date | undefined {
  return selected ?? fallback;
}
